import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "data",
  initialState: {
    dataPracticas: [
      {
        month: {
          id: "",
          name: "",
          value: {
            entresemana: [],
            findesemana: [],
          },
        },
      },
    ],
    isDataPracticasLoading: true,
    dataTeoria: [],
    tipoTeoria: "Presencial",
    fechaDespues: null,
    elementoSeleccionadoEnPracticas: "",
    elementoSeleccionadoEnTeoria: "",
    practicas: {
      tipo: "practicas",
      periodo: "entre_semana",
      personas: 1,
      data: {},
    },
    teoria: {
      tipo: "teoria",
      personas: 1,
      data: {},
    },
    extras: [],
    extrasInputListCM: [],
    extrasInputListEE: [],
    extrasInputListEC: [],
    resumen: {
      domain: "",
      lang: "",
      param_add_to_cart: "",
      variation_name: "",
      quantity_prod: "",
      attr_fecha_teoria: "",
      attr_fecha_practicas: "",
      attr_personas_cm: "",
      attr_personas_ln_express: "",
      param_add_certificado_medico: "",
      quantity_add_certificado_medico: "",
      param_add_expedicion_express: "",
      quantity_add_expedicion_express: "",
      param_add_envio_correo: "",
      quantity_add_envio_correo: "",
      id_prod: 0,
      variation_id_entresemana: 0,
      variation_value_entresemana: "",
      variation_id_findesemana: 0,
      variation_value_findesemana: "",
      page: "",
    },
    translation: "es",
  },
  reducers: {
    applyDataPracticas(state, action) {
      state.dataPracticas = action.payload;
    },
    setDataPracticasLoading(state, action) {
      state.isDataPracticasLoading = action.payload;
    },
    applyDataTeoria(state, action) {
      state.dataTeoria = action.payload;
    },
    applyPracticasData(state, action) {
      state.practicasentresemana = action.payload.entresemana;
      state.practicasfindesamana = action.payload.findesemana;
    },
    applyPracticas(state, action) {
      state.practicas.periodo = action.payload.periodo;
      state.practicas.personas = action.payload.personas;
      state.practicas.data = action.payload.data;
    },
    applyTeoria(state, action) {
      state.teoria.personas = action.payload.personas;
      state.teoria.data = action.payload.data;
    },
    setTipoTeoria(state, action) {
      state.tipoTeoria = action.payload;
    },
    applyExtras(state, action) {
      state.extras = action.payload;
    },
    removeExtras(state, action) {
      state.extras = state.extras.filter((e) => e !== action.payload);
    },
    setExtrasInputListCM(state, action) {
      state.extrasInputListCM = action.payload;
    },
    setExtrasInputListEE(state, action) {
      state.extrasInputListEE = action.payload;
    },
    setExtrasInputListEC(state, action) {
      state.extrasInputListEC = action.payload;
    },
    setResetExtrasState(state, action) {
      state.extrasInputListCM = [];
      state.extrasInputListEE = [];
      state.extrasInputListEC = [];
    },
    setFechaDespues(state, action) {
      state.fechaDespues = action.payload;
    },
    elementoSeleccionadoEnPracticas(state, action) {
      state.elementoSeleccionadoEnPracticas = action.payload;
    },
    elementoSeleccionadoEnTeoria(state, action) {
      state.elementoSeleccionadoEnTeoria = action.payload;
    },
    setResumenData(state, action) {
      state.resumen = action.payload;
    },
    setTranslation(state, action) {
      state.translation = action.payload;
    },
  },
});

export const dataActions = dataSlice.actions;

export default dataSlice;
